import { Link } from 'react-router-dom';
import { SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function TopBar() {
  return (
    <header className="topbar">
      <Link to="/" className="topbar__brand">
        <span className="topbar__mark" aria-hidden="true" />
        <span>
          <strong>{SITE_NAME}</strong>
          <small>{SITE_DOMAIN}</small>
        </span>
      </Link>
    </header>
  );
}
